import React from 'react';
import { Form, Col, Row, Typography, Space, Select, InputNumber, Input } from 'antd';
import { Button } from '@app/components/common/buttons/Button/Button';
import { Card } from '@app/components/common/Card/Card';
import { Tip } from './types';
import { useLocation, useNavigate } from 'react-router-dom';
import { postTip, updateTip } from '@app/api/admin.api';
import { notificationController } from '@app/controllers/notificationController';

interface LocationState {
    record: Tip;
}

const CreateTipPage: React.FC = () => {
    const { state } = useLocation();
    const record = state && (state as LocationState).record;
    const isUpdating = !!record;
    const navigate = useNavigate();

    const initialValues = record || { brand: 'ease', order: 0 };

    const onFinish = (values: any) => {
        const request = isUpdating ? updateTip(record.id, values) : postTip(values);
        request
            .then(() => {
                notificationController.success({
                    message: isUpdating ? 'Tip updated successfully.' : 'Tip created successfully.',
                    duration: 5,
                });
                navigate(-1);
            })
            .catch((error) => {
                notificationController.error({ message: error.message || error, duration: 5 });
            });
    };

    return (
        <Space size={'large'} direction={'vertical'} style={{ width: '100%' }}>
            <Typography.Title level={3}>{isUpdating ? 'Edit Tip' : 'Create Tip'}</Typography.Title>
            <Card>
                <Form
                    name={'tip-form'}
                    layout={'vertical'}
                    initialValues={initialValues}
                    onFinish={onFinish}
                    autoComplete={'off'}>
                    <Row gutter={{ xs: 10, md: 16, xl: 24 }}>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="brand"
                                label="Brand"
                                rules={[{ required: true, message: 'Please select a brand' }]}>
                                <Select
                                    options={[
                                        { value: 'ease', label: 'EASE' },
                                        { value: 'wavon', label: 'Wavon' },
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="order"
                                label="Order"
                                tooltip="Lower numbers appear earlier in the daily rotation"
                                rules={[{ required: true, message: 'Please input an order' }]}>
                                <InputNumber min={0} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                name="text"
                                label="Tip"
                                rules={[
                                    { required: true, message: 'Please input the tip text' },
                                    { max: 280, message: 'Tip must be 280 characters or fewer' },
                                ]}>
                                <Input.TextArea rows={3} maxLength={280} showCount />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
                                <Button type={'ghost'} block htmlType={'submit'}>
                                    {isUpdating ? 'Update' : 'Create'}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item wrapperCol={{ span: 18 }}>
                                <Button danger type={'ghost'} block onClick={() => navigate(-1)}>
                                    Cancel
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Space>
    );
};

export default CreateTipPage;
